import React, { ReactElement } from "react";

import CheckPermissions from "../CheckPermissions";

import { COMPONENTS, ERROR_TEXT } from "@utils/Constants";
import ErrorBoundary from "@utils/error-boundary/ErrorBoundary";

export const ProfileLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { Profile } = await import("@workflows/profile/Profile");
  const WrappedProfile = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.PROFILE}>
      <ErrorBoundary fallbackMessage={ERROR_TEXT.PROFILE}>
        <Profile />
      </ErrorBoundary>
    </CheckPermissions>
  );
  return { Component: WrappedProfile };
};
